
<template>
    <div>
        <gofix-card title="option period" v-bind:key="index + 'terms'" v-for="(item, index) in termsOption">
            <template slot="gofixCard:right_header">
                <div class="contract-attachment-action">
                    <b-button class="btnDelete" @click="removeOption(index,item)" title="Delete" v-b-tooltip.hover><i class="fa fa-trash-o"></i></b-button>
                </div>
            </template>
            <b-row>
                <b-col md="4">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input-date
                                v-model="item.extra_info.clientLetterDate"
                                popoverDirection="top"
                                label="client letter date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-number
                                label="contract sum"
                                v-model="item.contract_sum"
                                prefix="$">
                            </gofix-form-input-number>
                        </b-col>
                    </b-row>
                </b-col>
                <!-- <b-col md="4">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input-date
                                v-model="item.start_date"
                                popoverDirection="top"
                                label="option period start date">
                            </gofix-form-input-date>
                        </b-col>
                    </b-row>
                </b-col> -->
                <b-col md="8">
                    <b-row>
                        <b-col md="4">
                            <gofix-form-input-date
                                :minDate="new Date()"
                                required
                                :disabled="disableInput(item.end_date)"
                                v-model="item.end_date"
                                popoverDirection="top"
                                label="option period end date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="4">
                            <gofix-form-dropdown
                                v-if="item.type"
                                label="SOR Adjustment Mark"
                                :options="adjustmentMark"
                                v-model="item.type"
                                :filterable="false">
                            </gofix-form-dropdown>
                          </b-col>
                        <b-col md="4">
                            <gofix-form-input-number
                                label="SOR adjustment (%)"
                                v-model="item.sor_adjustment"
                                :integer-limit="3"
                                suffix="%">
                            </gofix-form-input-number>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </gofix-card>
    </div>
</template>
<script>
    import moment from 'moment';
    export default {
        name: 'contract-term-option',
        props: {
            termsOption: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        data() {
            return {
                adjustmentMark: [
                    {
                      value: 'up',
                      label: 'Mark Up'
                    },
                    {
                      value: 'down',
                      label: 'Mark Down'
                    }
                ]
            }
        },
        methods: {
            removeOption(index,item) {
                this.$emit('removeItem', 'terms_option', index, item);
            },
            disableInput(end_date) {
                if(!end_date) return false;
                return !moment(end_date).isAfter();
            }
        }
    }
</script>
